module.exports = __webpack_public_path__ + "static/img/new_02.92ed497.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new_02.jpg
// module id = ILWI
// module chunks = 0